import React from 'react'
import Alert from './Alert'

export * from './Alert'
export default React.memo(Alert)
